export default __webpack_public_path__ + "static/media/DJI_0940.MP4.00_04_09_02.Still010.fb7fe103.jpg";